var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsMobileGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-iphone-14 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.9998 3.5C9.34526 3.5 7.99976 4.8455 7.99976 6.5V25.5C7.99976 27.1545 9.34526 28.5 10.9998 28.5H20.9998C22.6543 28.5 23.9998 27.1545 23.9998 25.5V6.5C23.9998 4.8455 22.6543 3.5 20.9998 3.5H19.9998H11.9998H10.9998ZM10.9998 5.5H11.9998C11.9998 6.6045 12.8953 7.5 13.9998 7.5H17.9998C19.1043 7.5 19.9998 6.6045 19.9998 5.5H20.9998C21.5513 5.5 21.9998 5.9485 21.9998 6.5V25.5C21.9998 26.0515 21.5513 26.5 20.9998 26.5H10.9998C10.4483 26.5 9.99976 26.0515 9.99976 25.5V6.5C9.99976 5.9485 10.4483 5.5 10.9998 5.5Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsMobileGray);
export default __webpack_public_path__ + "static/media/iconsMobileGray.bbb32909455e6820ddf4c117376ab15f.svg";
export { ForwardRef as ReactComponent };